"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _actionMenu = _interopRequireDefault(require("../action-menu/action-menu"));

var _actionMenuTypes = _interopRequireDefault(require("./action-menu-types"));

var _actionMenuNames = _interopRequireDefault(require("./action-menu-names"));

const AppActionMenu = props => {
  const {
    items,
    onSelect,
    className
  } = props;
  const menuItems = items.map(item => ({
    value: item,
    name: _actionMenuNames.default[item]
  }));
  return /*#__PURE__*/_react.default.createElement(_actionMenu.default, {
    items: menuItems,
    onSelect: onSelect,
    className: (0, _classnames.default)('app-action-menu', className)
  });
};

AppActionMenu.propTypes = {
  items: _propTypes.default.arrayOf(_propTypes.default.oneOf(Object.values(_actionMenuTypes.default))).isRequired,
  onSelect: _propTypes.default.func.isRequired,
  className: _propTypes.default.string
};
AppActionMenu.defaultProps = {
  className: ''
};
var _default = AppActionMenu;
exports.default = _default;